var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 125,
    viewBox: "0 0 126 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9994 104.167C86.0113 104.167 104.666 85.512 104.666 62.5C104.666 39.4881 86.0113 20.8333 62.9994 20.8333C39.9875 20.8333 21.3327 39.4881 21.3327 62.5C21.3327 85.512 39.9875 104.167 62.9994 104.167ZM115.083 62.5C115.083 91.2646 91.7639 114.583 62.9994 114.583C34.2345 114.583 10.916 91.2646 10.916 62.5C10.916 33.7351 34.2345 10.4166 62.9994 10.4166C91.7639 10.4166 115.083 33.7351 115.083 62.5Z",
    fill: "#47D881"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2077 41.6667C68.2077 38.7902 65.8758 36.4584 62.9993 36.4584C60.1229 36.4584 57.791 38.7902 57.791 41.6667V62.5C57.791 65.3765 60.1229 67.7084 62.9993 67.7084C65.8758 67.7084 68.2077 65.3765 68.2077 62.5V41.6667Z",
    fill: "#47D881"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8125 80.7291C70.8125 76.4144 67.3147 72.9166 63 72.9166C58.6853 72.9166 55.1875 76.4144 55.1875 80.7291C55.1875 85.0439 58.6853 88.5416 63 88.5416C67.3147 88.5416 70.8125 85.0439 70.8125 80.7291Z",
    fill: "#47D881"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2d9b29b6eafa9b05e0889ea4fd0aae03.svg";
export { ForwardRef as ReactComponent };